import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { CustomValuesCategoriesProvider } from '@helpers/hooks/pages/dashboard/customValues/useCustomValuesCategories';

import Wrapper from '@components/Dashboard/CustomValuesCategories/Wrapper';
import NoAccess from '@components/common/core/Utils/NoAccess';

const CustomSpendsCategory: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_custom_value_full_write_access ||
    accessManagementData?.group?.has_custom_value_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <CustomValuesCategoriesProvider>
      <Wrapper />
    </CustomValuesCategoriesProvider>
  );
};

export default CustomSpendsCategory;
